// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UploadMediaOverlay Component Styles */
/* NOTE: No backdrop here — GlobalPopupProvider owns the overlay/backdrop layer. */

/* Modal shell */
.scl--cms-components-uploadMedia-modal {
  position: relative;
  width: 941px;
  height: 602px;
  background: #FFFFFF;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.12);
}

/* ── Header ── */
.scl--cms-components-uploadMedia-header {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 65px;
  flex-shrink: 0;
  background: #F8F9FB;
  border-bottom: 1px solid rgba(229, 229, 231, 0.5);
  display: flex;
  align-items: center;
  padding: 0 24px;
}

.scl--cms-components-uploadMedia-title {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 36px;
  color: #323539;
  flex: 1;
  margin: 0;
}

.scl--cms-components-uploadMedia-closeBtn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-30%);
}

/* ── Body ── */
.scl--cms-components-uploadMedia-body {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  position: relative;
}

/* Vertical divider */
.scl--cms-components-uploadMedia-divider {
  position: absolute;
  left: 483px;
  top: 0;
  bottom: 0;
  width: 1px;
  background: rgba(229, 229, 231, 0.5);
  pointer-events: none;
}

/* ── Left Panel ── */
.scl--cms-components-uploadMedia-left {
  width: 483px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.scl--cms-components-uploadMedia-sectionLabel {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #8A8B8F;
  padding: 16px 24px 10px 24px;
}

.scl--cms-components-uploadMedia-uploadWrapper {
  padding: 0 24px;
  display: flex;
  justify-content: center;
}

/* ── Recent uploads section ── */
.scl--cms-components-uploadMedia-recentSection {
  margin-top: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.scl--cms-components-uploadMedia-recentHeader {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 24px;
}

.scl--cms-components-uploadMedia-recentLabel {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 22px;
  color: #8A8B8F;
}

.scl--cms-components-uploadMedia-recentDivider {
  width: 100%;
  height: 1px;
  background: rgba(229, 229, 231, 0.5);
}

/* Content area — centers empty state, aligns list to top */
.scl--cms-components-uploadMedia-recentContent {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 16px 24px;
  overflow-y: auto;
}

/* ── Recent upload list ── */
.scl--cms-components-uploadMedia-recentList {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

/* Each RecentMediaUpload fills the list width */
.scl--cms-components-uploadMedia-recentList .scl--cms-components-recentMediaUpload {
  max-width: 100%;
  width: 100%;
}

/* ── Empty state ── */
.scl--cms-components-uploadMedia-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.scl--cms-components-uploadMedia-emptyText {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #8A8B8F;
  opacity: 0.8;
}

/* ── Right Panel ── */
.scl--cms-components-uploadMedia-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.scl--cms-components-uploadMedia-metaFields {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 24px;
  gap: 25px;
  margin-top: 8px;
}

.scl--cms-components-uploadMedia-metaFields .scl--cms-components-textField-container,
.scl--cms-components-uploadMedia-metaFields .scl--cms-components-textArea-container {
  width: 100%;
}

/* ── Footer — Button styles owned by @core/uilibrary ── */
.scl--cms-components-uploadMedia-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 0 24px 23px 24px;
  position: absolute;
  right: 0;
  bottom: 0;
}

.scl--cms-components-uploadMedia-modal .scl--components-empty-page-icon svg{
  width: 58px;
  height: 46px;
}
.scl--cms-components-uploadMedia-modal .scl--components-empty-page-title{
  color: var(--typography-text-body-secondary);
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/texteditor-fs-cp/upload-media-overlay/css/uploadMediaOverlay.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC,kFAAkF;;AAElF,gBAAgB;AAChB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,OAAO;EACP,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;;AAEA,2DAA2D;AAC3D;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,4CAA4C;EAC5C,gBAAgB;AAClB","sourcesContent":["/* UploadMediaOverlay Component Styles */\n/* NOTE: No backdrop here — GlobalPopupProvider owns the overlay/backdrop layer. */\n\n/* Modal shell */\n.scl--cms-components-uploadMedia-modal {\n  position: relative;\n  width: 941px;\n  height: 602px;\n  background: #FFFFFF;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.12);\n}\n\n/* ── Header ── */\n.scl--cms-components-uploadMedia-header {\n  box-sizing: border-box;\n  position: relative;\n  width: 100%;\n  height: 65px;\n  flex-shrink: 0;\n  background: #F8F9FB;\n  border-bottom: 1px solid rgba(229, 229, 231, 0.5);\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n}\n\n.scl--cms-components-uploadMedia-title {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 22px;\n  line-height: 36px;\n  color: #323539;\n  flex: 1;\n  margin: 0;\n}\n\n.scl--cms-components-uploadMedia-closeBtn {\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-30%);\n}\n\n/* ── Body ── */\n.scl--cms-components-uploadMedia-body {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-height: 0;\n  position: relative;\n}\n\n/* Vertical divider */\n.scl--cms-components-uploadMedia-divider {\n  position: absolute;\n  left: 483px;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: rgba(229, 229, 231, 0.5);\n  pointer-events: none;\n}\n\n/* ── Left Panel ── */\n.scl--cms-components-uploadMedia-left {\n  width: 483px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.scl--cms-components-uploadMedia-sectionLabel {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n  color: #8A8B8F;\n  padding: 16px 24px 10px 24px;\n}\n\n.scl--cms-components-uploadMedia-uploadWrapper {\n  padding: 0 24px;\n  display: flex;\n  justify-content: center;\n}\n\n/* ── Recent uploads section ── */\n.scl--cms-components-uploadMedia-recentSection {\n  margin-top: 16px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.scl--cms-components-uploadMedia-recentHeader {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 0 24px;\n}\n\n.scl--cms-components-uploadMedia-recentLabel {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 22px;\n  color: #8A8B8F;\n}\n\n.scl--cms-components-uploadMedia-recentDivider {\n  width: 100%;\n  height: 1px;\n  background: rgba(229, 229, 231, 0.5);\n}\n\n/* Content area — centers empty state, aligns list to top */\n.scl--cms-components-uploadMedia-recentContent {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  padding: 16px 24px;\n  overflow-y: auto;\n}\n\n/* ── Recent upload list ── */\n.scl--cms-components-uploadMedia-recentList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n/* Each RecentMediaUpload fills the list width */\n.scl--cms-components-uploadMedia-recentList .scl--cms-components-recentMediaUpload {\n  max-width: 100%;\n  width: 100%;\n}\n\n/* ── Empty state ── */\n.scl--cms-components-uploadMedia-empty {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.scl--cms-components-uploadMedia-emptyText {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  text-align: center;\n  color: #8A8B8F;\n  opacity: 0.8;\n}\n\n/* ── Right Panel ── */\n.scl--cms-components-uploadMedia-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.scl--cms-components-uploadMedia-metaFields {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 0 24px;\n  gap: 25px;\n  margin-top: 8px;\n}\n\n.scl--cms-components-uploadMedia-metaFields .scl--cms-components-textField-container,\n.scl--cms-components-uploadMedia-metaFields .scl--cms-components-textArea-container {\n  width: 100%;\n}\n\n/* ── Footer — Button styles owned by @core/uilibrary ── */\n.scl--cms-components-uploadMedia-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  padding: 0 24px 23px 24px;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n\n.scl--cms-components-uploadMedia-modal .scl--components-empty-page-icon svg{\n  width: 58px;\n  height: 46px;\n}\n.scl--cms-components-uploadMedia-modal .scl--components-empty-page-title{\n  color: var(--typography-text-body-secondary);\n  font-weight: 400;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
